import { Col, Form, InputNumber } from "antd";
import { MazakaInputProps } from "models/Client/MazakaInputModel";
import { FC } from "react";
const FormatThousandsNumber: FC<MazakaInputProps> = (props) => {

  return (
    <>
      <Col
        className={props.colClassName}
        span={props.span}
        xs={props.xs}
        sm={props.sm}
        md={props.md}
        lg={props.lg}
        xl={props.xl}
        xxl={props.xxl}
      >
        <Form.Item
          className={props.className}
          name={props.name}
          initialValue={props.initialValue}
          rules={props.rules}
          label={props.label}
          colon={props.colon}
          labelAlign={props.labelAlign}
          labelCol={props.labelCol}
          wrapperCol={props.wrapperCol}
          hasFeedback={props.hasFeedback}
          tooltip={props.tooltip}
          noStyle={props.noStyle}
          help={props.help}
          validateStatus={props.validateStatus}
        >
          
           <>
              <InputNumber
                className={`number rounded !w-full ${props.inputClassName}`}
                onBlur={props.onBlur}
                onChange={props.onInputNumberChange}
                prefix={props?.prefix}
                suffix={props?.suffix}
                pattern={props.pattern}
                disabled={props?.disabled}
                min={props.min}
                max={props.max}
                bordered={props.bordered}
                size={props.size}
                type={props?.type}
                placeholder={props.placeholder}
                addonAfter={props.addonAfter}
                addonBefore={props.addonBefore}
                formatter={(value) =>
                  value
                    ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                    : ""
                }
                parser={(value) =>
                  value ? Number(value.replace(/\./g, "").replace(",", ".")) : ""
                }
              />
            </>
        </Form.Item>
      </Col>
    </>
  );
};

export default FormatThousandsNumber;
